import { WithTranslator } from "Components/Generic/Translator";
import { getTranslatedFieldLabel } from "Utils/Field";
import { IKeyValue } from "../IKeyValue";
import { KeyValueGrid } from "../KeyValueGrid";
import { IItemKeyValueGridProps } from "./IItemKeyValueGridProps";

export const ItemKeyValueGrid = WithTranslator((props: IItemKeyValueGridProps): JSX.Element => {
  const {
    items, entityType, translator, ...remainginProps
  } = props;

  const translatedItems = items.map<IKeyValue>((item) => ({
    ...item,
    key: getTranslatedFieldLabel(item.key, entityType, translator)
  }));

  return <KeyValueGrid items={translatedItems} {...remainginProps} />;
});
